import promisifyObserver from '../utils/promisifyObserver.js';

const entryType = 'first-input';

export default function fid(window, performance, PerformanceObserver) {
    return promisifyObserver(PerformanceObserver, entryType, (entries, resolve) => {
        const {name, startTime, duration} = entries[0];
        resolve({
            entryType,
            action: name,
            startTime: Math.round(startTime),
            duration: Math.round(duration),
            detail: name
        });
    });
}
